import React from "react";
import PropTypes from "prop-types";
import bagIcon from "./DC_Icon.svg";
import styles from "./StatsTotalCard.module.css";

export function StatsSummaryCards({ total, title }) {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
        <img src={bagIcon} alt="bagIcon" />
      </div>

      <div className={styles.details}>
        {title && <p className={styles.title}>{title}</p>}
        {total && <p className={styles.total}>{total}</p>}
      </div>
    </div>
  );
}

StatsSummaryCards.propTypes = {
  total: PropTypes.string,
  title: PropTypes.string,
};
